import { Typography } from '@mui/material';
import { lightBlue } from '@mui/material/colors';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../ReactComponent';
import CodDecisaoMovCNJ from '../CodDecisaoMovCNJ';
import PreSessaoEmentaDecisao from './components/PreSessaoEmentaDecisao';
import { Box } from '@mui/system';
import PartesProcesso from '@/components/PartesProcesso';
import { computed, makeObservable } from 'mobx';
import RodapePainelDecisao from './components/RodapePainelDecisao';
import Indicadores from '../Indicadores';
import QuantidadePartesAutoras from './components/QuantidadePartesAutoras';

class PainelDecisaoPreSessao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            qtdPartesAutoras: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get qtdPartesAutoras() {
        if (
            this.registro?.detalhes?.quantidadePartesAutoras &&
            Number.isFinite(this.registro.detalhes.quantidadePartesAutoras)
        ) {
            return Number.parseInt(this.registro.detalhes.quantidadePartesAutoras);
        }

        return 0;
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    flexGrow: '2'
                }}
            >
                <CodDecisaoMovCNJ
                    registro={this.registro}
                    id="decisao"
                />

                <Indicadores registro={this.registro} />

                <Box sx={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                    <Box sx={{ display: 'flex', flex: 6 }}>
                        <PreSessaoEmentaDecisao registro={this.registro} />
                    </Box>
                    <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', pb: 0.5 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography sx={{ fontWeight: 'bold', color: lightBlue[900], ml: 2, mt: 1 }}>
                                Partes:
                            </Typography>
                            {!!this.qtdPartesAutoras && (
                                <QuantidadePartesAutoras
                                    registro={this.registro}
                                    fontSize={this.qtdPartesAutoras > 1 ? '0.8rem' : '0.9rem'}
                                />
                            )}
                        </Box>
                        <Box sx={{ display: 'flex', flex: 1, px: 2, flexDirection: 'column' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                    borderRadius: '4px',
                                    flex: 1,
                                    overflowY: 'auto'
                                }}
                            >
                                <PartesProcesso
                                    registro={this.registro}
                                    ocultarRepresentantes={true}
                                    visualizacaoVertical={true}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <RodapePainelDecisao registro={this.registro} />
            </div>
        );
    }
}

export default inject('stores')(observer(PainelDecisaoPreSessao));
